import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { RightsContext } from 'providers/RightsContext';
import { Button, Grid } from '@mui/material';

const DocumentUploadTransitionComponent = ({ documents, availableTransitions, saving, onBulkTransitionStateChangeClick }) => {
  const { readOnlyFull, uploadDocumentWrite } = useContext(RightsContext);

  const documentAttachmentsTransitions = useMemo(() => {
    const transitionsList = [];
    documents.forEach(document => {
      if (document.document.isSelected) {
        document.document.availableTransitions.forEach(transition => {
          const matchingTransition = availableTransitions.some(
            transitionToCheck =>
              transitionToCheck.finalStateId === transition.finalStateId && transitionToCheck.initialStateId === transition.initialStateId
          );
          if (matchingTransition) {
            transitionsList.push({
              attachmentId: document.document.attachmentId,
              flowId: transition.flowId,
              transitionId: transition.transitionId,
              finalStateId: transition.finalStateId,
              finalStateName: transition.finalStateName,
              initialStateId: transition.initialStateId,
              isInitialOrPostUploadTransition: transition.isInitialOrPostUploadTransition,
              finalStateActiveProduct: transition.finalStateActiveProduct
            });
          }
        });
      }
    });
    return transitionsList;
  }, [documents, availableTransitions]);

  return (
    <Grid container spacing={1}>
      {availableTransitions &&
        availableTransitions.map((item, idx) => (
          <Grid item key={idx}>
            <Button
              id={'docAttachmentStateBtn_' + idx}
              variant='outlined'
              color='primary'
              onClick={onBulkTransitionStateChangeClick(documentAttachmentsTransitions, item.finalStateId)}
              disabled={saving || readOnlyFull || !uploadDocumentWrite}
            >
              {item.finalStateName}
            </Button>
          </Grid>
        ))}
    </Grid>
  );
};

DocumentUploadTransitionComponent.propTypes = {
  documents: PropTypes.array.isRequired,
  availableTransitions: PropTypes.array.isRequired,
  saving: PropTypes.bool.isRequired,
  onBulkTransitionStateChangeClick: PropTypes.func.isRequired
};

export default DocumentUploadTransitionComponent;
